import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { connect, useSelector } from 'react-redux';

import { array, bool, func, shape, string } from 'prop-types';

import EsmsDialog from '../../components/EsmsDialog';

import ActionBar from '../../components/ActionBar';
import TimestampFilter from '../../components/RuleExceptionsTable/TimestampFilter';
import { fetchWeatherData }  from '../../actions/architectActions';

import WeatherDataTable from '../Architect/WeatherDataTable';
import classes from './WeatherDataModal.module.css';

const WeatherDataModal = ({
    close,
    errors,
    fetchWeatherData,
    weatherData,
    history,
    loading,
    location,
    open,
    selectedNode,
    title
}) => {

    const tableWeatherData = useSelector(
        ({ architect: { weatherData }}) => weatherData
    );

    function fetchOnRender() {
        const params = new URLSearchParams(location.search);
        const endDate = moment(params.get('endTimestamp') || undefined).local();
        const startDate = moment(params.get('startTimestamp') || undefined).local();
        if (!params.has('endTimestamp')) {
            endDate.startOf('day').add('4', 'hours');
        }
        if (!params.has('startTimestamp')) {
            startDate.startOf('day');
        }
        if (selectedNode.id && open) {
            fetchWeatherData({
                siteId:         selectedNode.id,
                startTimestamp: startDate.toISOString(),
                endTimestamp:   endDate.toISOString()
            });
        }
    }

    function parseEndTimestamp(searchParams) {
        const params = new URLSearchParams(searchParams);
        const endDate = moment(params.get('endTimestamp') || undefined).local();
        if (!params.has('endTimestamp')) {
            endDate.startOf('day').add('4', 'hours');
        }
        return endDate;
    }
    
    function parseStartTimestamp(searchParams) {
        const params = new URLSearchParams(searchParams);
        const startDate = moment(params.get('startTimestamp') || undefined).local();
        if (!params.has('startTimestamp')) {
            startDate.startOf('day');
        }
        return startDate;
    }

    function handleFilterChange(filterName, value) {
        const newParams = new URLSearchParams(location.search);
        if (value) {
            newParams.set(filterName, value.toISOString());
        } else {
            newParams.delete(filterName);
        }
        newParams.delete('page');
        history.replace({
            pathname: location.pathname,
            search:   newParams.toString()
        });
    }

    const [startTimestamp, setStartTimestamp] =
        useState(parseStartTimestamp(location.search));
    const [endTimestamp, setEndTimestamp] =
        useState(parseEndTimestamp(location.search));

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const endTimestamp = parseEndTimestamp(params);
        const startTimestamp = parseStartTimestamp(params);
        setStartTimestamp(startTimestamp);
        setEndTimestamp(endTimestamp);

        if (selectedNode.id && open) {
            fetchWeatherData({
                siteId:         selectedNode.id,
                startTimestamp: startTimestamp.toISOString(),
                endTimestamp:   endTimestamp.toISOString()
            });
        }
    }, [location.search]);

    return (
        <EsmsDialog
            errors={errors}
            open={open}
            onClose={close}
            onConfirm={close}
            onRendered={fetchOnRender}
            title={title}
            isLoading={loading}
            confirmText="Close"
            className={classes.modal}
        >
            <div className={classes.contentContainer}>
                <ActionBar
                    startAdornments={(
                        <TimestampFilter
                            endTimestamp={endTimestamp}
                            onFilterChange={handleFilterChange}
                            startTimestamp={startTimestamp}
                        />
                    )}
                />
                <WeatherDataTable weatherData={tableWeatherData} isLoading={loading} />
            </div>
        </EsmsDialog>
    );
};

WeatherDataModal.defaultProps = {
    idType:           '',
    weatherData:      [],
    fetchWeatherData: () => {},
    isLoading:        false,
    location:         {},
    open:             false,
    title:            ''
};

WeatherDataModal.propTypes = {
    error:            string,
    fetchWeatherData: func,
    idType:           string,
    weatherData:      array,
    isLoading:        bool,
    location:         shape({
        search: string
    })
};

export const mapStateToProps = state => {
    return {
        weatherData: state.weatherData,
        loading:     state.architect.loading
    };
};

const mapDispatchToProps = {
    fetchWeatherData
};

export default connect(mapStateToProps, mapDispatchToProps)(WeatherDataModal);
